export default __webpack_public_path__ + "static/HeroImage-bb5ec259a17fb11655a4fc71fdfed52e.jpg";